<div class="remittance-container">
  <div class="d-flex flex-column gap-1">
    <span class="remittance-label">{{ activeRemittance?.scheduledRemittanceName }}</span>
    <div class="employer-meta d-flex gap-1">
      <div class="employer-name">{{ activeRemittance?.employerName }}</div>
      <div class="dot">•</div>
      <div class="employer-id">{{ activeRemittance?.employerId | leadingZero : 8 }}</div>
    </div>
    <div class="end-date-label" i18n>
      Scheduled End Date: {{ activeRemittance?.formattedScheduledRemittanceEndDate }}
    </div>
  </div>
  <div class="d-flex gap-3 my-auto">
    <div class="d-flex gap-2">
      <span class="status-label" i18n>Status:</span>
      <app-status-pill [statusPill]="activeRemittance?.scheduledRemittanceStatusPill" />
    </div>
    <app-tertiary-button
      (buttonClicked)="goToRemittance()"
      [size]="BaseButtonSizeEnum.sm"
      [leftIconSrc]="'assets/icons/blue/ExternalLink.svg'"
      i18n>
      View
    </app-tertiary-button>
  </div>
</div>
